export default [
  {
    resource: "administration",
    header: "Reserves",
  },
  {
    action: "manage",
    resource: "administration",
    icon: "BookOpenIcon",
    title: "Llistat",
    route: "foravila-bookings-list",
  },
  {
    action: "manage",
    resource: "administration",
    icon: "CalendarIcon",
    title: "Calendari",
    route: "foravila-bookings-calendar",
  },
  {
    action: "manage",
    resource: "administration",
    icon: "ClipboardIcon",
    title: "Planning",
    route: "foravila-bookings-planning",
  },
  {
    action: "manage",
    resource: "administration",
    icon: "LockIcon",
    title: "Fiances",
    route: "foravila-bookings-security-deposits",
  },
  {
    action: "manage",
    resource: "administration",
    icon: "DollarSignIcon",
    title: "Pagaments finals",
    route: "foravila-bookings-final-payments",
  },
  {
    action: "manage",
    resource: "administration",
    icon: "AlertTriangleIcon",
    title: "Incidències",
    route: "foravila-incidences-list",
  },
  {
    action: "manage",
    resource: "administration",
    icon: "ClipboardIcon",
    title: "Neteges",
    route: "foravila-cleanings-planning",
  },
  {
    action: "manage",
    resource: "all",
    icon: "MessageCircleIcon",
    title: "WhatsApp",
    route: "foravila-whatsapp",
  },
];
